<template>
  <div class="login-page">
    <div class="login-card">
      <img
        src="../../assets/SafetyPlanner_logo.jpg"
        class="login-logo"
        alt="safetyPlanner"
      />
      <h1 v-if="$route.params.mode === 'login'" class="login-title">
        {{ $t("login.welcomeBack") }}
      </h1>
      <login ref="login" v-if="$route.params.mode === 'login'" />
      <resetPassword
        ref="resetPassword"
        v-if="$route.params.mode === 'resetPassword'"
      />
    </div>
    <a
      class="login-footer"
      href="https://www.safetyplanner.de"
      target="_blank"
      rel="noopener"
    >
      www.safetyplanner.de
    </a>
  </div>
</template>
<script>
import login from "../../views/login/login.vue";
import resetPassword from "../../views/login/resetPassword.vue";

export default {
  components: { login, resetPassword },
  data: () => ({}),
  methods: {
    routerPush({ name, params }) {
      if (this.$route.params.mode === params.mode) return;

      this.$router.push({
        name,
        params,
      });
    },
  },
};
</script>
<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px 80px;
  background: #45d6f41a;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 8px;
  padding: 48px 56px 40px;
}

.login-logo {
  display: block;
  width: 170px;
  margin: 0 auto;
}

.login-title {
  margin: 32px 0 36px;
  font-family: Roboto, sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  color: #1a5561;
}

.login-footer {
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #1a5561;
  text-decoration: none;
}

.login-footer:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .login-card {
    padding: 36px 24px 32px;
  }
}
</style>
